
import { Component, Prop, Vue, Watch, Inject } from "vue-property-decorator";
import Search from "@/components/semantics/HomeSearch.vue";
import Nav from "@/components/semantics/KunMingNavigation.vue";
import TitleHeader from "@/components/base/table/header/LeftLineHeader.vue";
import { mapState } from "vuex";
import { TitleConfig, RouteConfig } from "@/config";
import { State, Getter, Action, Mutation } from "vuex-class";
import { dispatchLogOut } from "@/store/dispatches";
import { deepClone, getStorage, getParentArea } from "@/common/utils";
@Component({
	name: "NavHeader",
	components: {
		Nav,
		TitleHeader,
		Search
	}
})
export default class NavHeader extends Vue {
	@Action("account/getAuthernData") private getAuthern: any;
	@State("cityData") private cityData: any;
	@Action("getHotCity") private getHotCityData: any;
	@State("basic") private basic: any;
	@Getter("city") private city: any;
	@Getter("account") private account: any;
	@Getter("phone") private phone: any;
	@Getter("company") private userName: any;
	@Getter("role") private role: any;
	@Mutation("setCity") private setCity: any;
	company: any = "";
	@Watch("city", {
		immediate: true,
		deep: true
	})
	handleCityChange(newValue: any, oldValue: any) {}
	is_login = false;
	pcm: any = TitleConfig;
	lightenList: any = RouteConfig.lightenList;
	enHeaderArr: Array<any> = [];
	enArr: Array<any> = [];
	activeEn = 0;
	activeProvince = 0;
	provinceArr: Array<any> = [];
	cityArr: Array<any> = [];
	hotCityArr: Array<any> = [];
	visible = false;
	created() {
		this.getData();
	}
	getData() {}
	async getBasicData() {
		const data = await this.getAuthern({ idNature: this.role });

		if (data) {
			const { unitName } = data;
			this.company = unitName;
		}
	}
	selectCity(item: any) {
		this.visible = false;
		// this.city = item;
		this.setCity(item);
		// location.reload();
	}
	clickProvinceOptin(index: any) {
		const cityArr = deepClone(this.provinceArr[index]).cities;

		const filterCityArr = cityArr.map(
			({ cityId, provinceId, cityName }: any) => {
				if (cityName === "市辖区") {
					const provinceName = this.provinceArr[index].provinceName;
					return {
						id: cityId,
						name: provinceName,
						provinceId
					};
				}
				return {
					id: cityId,
					name: cityName,
					provinceId
				};
			}
		);

		this.cityArr = filterCityArr;
	}
	clickEnOption(index: any) {
		this.activeEn = index;
		switch (index) {
			case 0:
				this.getHotCity();
				break;
			default:
				this.getEnCity();
				break;
		}
	}
	areaOption = this.$root.$data.areaOption;
	async getHotCity() {
		const res = await this.getHotCityData();
		if (res) {
			this.cityArr = res.map(({ code: id, name }: any) => {
				const provinceItem: any = getParentArea(this.areaOption, id);
				const provinceId = provinceItem ? provinceItem.value : "";
				return {
					id,
					name,
					provinceId
				};
			});
		}
	}
	getEnCity() {
		const cityData = deepClone(this.cityData);
		const en = this.enArr[this.activeEn - 1];
		const provinceArr = cityData.filter(({ initials }: any) => {
			return initials === en;
		});

		this.provinceArr = provinceArr;
		this.clickProvinceOptin(this.activeProvince);
	}
	async getCityData() {
		this.clickEnOption(this.activeEn);
		const cityData = deepClone(this.cityData);
		// en filter
		const enHeaderArr: any = [];

		cityData.map(({ provinceName, provinceId, initials }: any) => {
			if (enHeaderArr.indexOf(initials) === -1) {
				enHeaderArr.push(initials);
			}
			return { en: initials };
		});
		const enArr = Object.assign([], enHeaderArr);

		this.enArr = enArr;
		enHeaderArr.unshift("热门城市");
		this.enHeaderArr = enHeaderArr;
	}
	toUser() {
		if (this.role) {
			this.$router.push({ path: `/${this.role}/home` });
		}
	}
	toLogin() {
		this.$router.push({ path: "/login" });
	}
	toRegist() {
		this.$router.push({ path: "/regist" });
	}
	logOut() {
		this.$router.push({ path: "/login" });
		dispatchLogOut();
	}
	handleClick() {}
	@Watch("role")
	handleRoleChange(newValue: any, oldValue: any) {}
}
